import { _ as r } from "./atoms-v21328.js";
var t = r, a = function() {
  try {
    var e = t(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), v = a;
export {
  v as _
};
